import { post } from '../api';

const postResource = ({ type, data, config }) => post(`/${type}`, { data }, config);

export default postResource;
